"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookInspectionEnquiryResponseDtoStatusEnum = exports.BookInspectionEnquiryResponseDtoEnquiryTypeEnum = void 0;
exports.instanceOfBookInspectionEnquiryResponseDto = instanceOfBookInspectionEnquiryResponseDto;
exports.BookInspectionEnquiryResponseDtoFromJSON = BookInspectionEnquiryResponseDtoFromJSON;
exports.BookInspectionEnquiryResponseDtoFromJSONTyped = BookInspectionEnquiryResponseDtoFromJSONTyped;
exports.BookInspectionEnquiryResponseDtoToJSON = BookInspectionEnquiryResponseDtoToJSON;
exports.BookInspectionEnquiryResponseDtoToJSONTyped = BookInspectionEnquiryResponseDtoToJSONTyped;
var OfferUnderListingDto_1 = require("./OfferUnderListingDto");
var BookInspectionEnquiryDetailsDto_1 = require("./BookInspectionEnquiryDetailsDto");
/**
 * @export
 */
exports.BookInspectionEnquiryResponseDtoEnquiryTypeEnum = {
    Inspection: 'inspection',
    DocumentRequest: 'document_request',
    GeneralEnquiry: 'general_enquiry',
    ListingCrmEnquiry: 'listing_crm_enquiry',
    PropertyValuation: 'property_valuation',
    ListProperty: 'list_property'
};
/**
 * @export
 */
exports.BookInspectionEnquiryResponseDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the BookInspectionEnquiryResponseDto interface.
 */
function instanceOfBookInspectionEnquiryResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('enquiryType' in value) || value['enquiryType'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('bookInspectionEnquiry' in value) || value['bookInspectionEnquiry'] === undefined)
        return false;
    if (!('listing' in value) || value['listing'] === undefined)
        return false;
    return true;
}
function BookInspectionEnquiryResponseDtoFromJSON(json) {
    return BookInspectionEnquiryResponseDtoFromJSONTyped(json, false);
}
function BookInspectionEnquiryResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'enquiryId': json['enquiryId'],
        'enquiryType': json['enquiryType'],
        'userId': json['userId'],
        'receiverId': json['receiverId'] == null ? undefined : json['receiverId'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'bookInspectionEnquiry': (0, BookInspectionEnquiryDetailsDto_1.BookInspectionEnquiryDetailsDtoFromJSON)(json['bookInspectionEnquiry']),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoFromJSON)(json['listing']),
    };
}
function BookInspectionEnquiryResponseDtoToJSON(json) {
    return BookInspectionEnquiryResponseDtoToJSONTyped(json, false);
}
function BookInspectionEnquiryResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'enquiryId': value['enquiryId'],
        'enquiryType': value['enquiryType'],
        'userId': value['userId'],
        'receiverId': value['receiverId'],
        'status': value['status'],
        'createdAt': value['createdAt'].toISOString(),
        'bookInspectionEnquiry': (0, BookInspectionEnquiryDetailsDto_1.BookInspectionEnquiryDetailsDtoToJSON)(value['bookInspectionEnquiry']),
        'listing': (0, OfferUnderListingDto_1.OfferUnderListingDtoToJSON)(value['listing']),
    };
}
